// Mappatura degli stati da italiano a inglese
const STATUS_MAPPING = {
    "Incompleto": "Incomplete",
    "Rev. Modellista": "Modelist Rev.",
    "Rev. Spaarkly": "Spaarkly Rev.",
    "Rev. Cliente": "Client Rev.",
    "In Pubblicazione": "In Publication",
    "Pubblicato": "Published"
};

// Ordine degli stati nel flusso di lavoro
const STATUS_ORDER = [
    "Incomplete",
    "Modelist Rev.",
    "Spaarkly Rev.",
    "Client Rev.",
    "In Publication",
    "Published"
];

// Definizione dei ruoli e dei loro permessi
const ROLE_PERMISSIONS = {
    Admin: {
        canModifyCoefficients: true,
        canView3DAssets: true,
        canModifyTagsBadges: true,
        priorityAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        variantAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canViewNotes: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canAssignTo: true,
    },
    Cliente: {
        canModifyCoefficients: false,
        canView3DAssets: false,
        canModifyTagsBadges: false,
        priorityAccessStates: ["Client Rev.", "In Publication", "Published"],
        variantAccessStates: ["Client Rev.", "In Publication", "Published"],
        canViewNotes: ["Client Rev.", "In Publication", "Published", 'Spaarkly Rev.'],
        canAssignTo: false,
    },
    Modellista: {
        canModifyCoefficients: true,
        canView3DAssets: true,
        canModifyTagsBadges: true,
        priorityAccessStates: ["Incomplete", "Modelist Rev."],
        variantAccessStates: ["Incomplete", "Modelist Rev."],
        canViewNotes: ["Incomplete", "Modelist Rev."],
        canAssignTo: false,
    },
    ModellerSupervisor: {
        canModifyCoefficients: true,
        canView3DAssets: true,
        canModifyTagsBadges: true,
        priorityAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        variantAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canViewNotes: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canAssignTo: true,
    },
    Validator: {
        canModifyCoefficients: false,
        canView3DAssets: false,
        canModifyTagsBadges: true,
        priorityAccessStates: ["Client Rev.", "In Publication", "Published"],
        variantAccessStates: ["Client Rev.", "In Publication", "Published"],
        canViewNotes: ["Client Rev.", "In Publication", "Published"],
        canAssignTo: false,
    },
    Guest: {
        canModifyCoefficients: true,
        canView3DAssets: false,
        canModifyTagsBadges: true,
        priorityAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        variantAccessStates: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canViewNotes: ["Incomplete", "Modelist Rev.", "Spaarkly Rev.", "Client Rev.", "In Publication", "Published"],
        canAssignTo: false,
    }
};

// Funzione per verificare se un ruolo ha un determinato permesso
export const hasPermission = (role, permission) => {
    if (!ROLE_PERMISSIONS[role]) {
        return false;
    }
    return ROLE_PERMISSIONS[role][permission] || false;
};

// Può modificare i coefficienti
export const canModifyCoefficients = (role) => {
    return hasPermission(role, 'canModifyCoefficients');
};

// Può vedere gli asset 3D
export const canView3DAssets = (role) => {
    return hasPermission(role, 'canView3DAssets');
};

// Può modificare la priorità per uno stato specifico
export const canModifyPriority = (role, variantStatus) => {
    if (!ROLE_PERMISSIONS[role]) {
        return false;
    }
    const englishStatus = STATUS_MAPPING[variantStatus] || variantStatus;
    return ROLE_PERMISSIONS[role].priorityAccessStates.includes(englishStatus);
};

// Controlla se una variante è cliccabile in base al ruolo dell'utente e lo stato della variante
export const isVariantClickable = (role, variantStatus) => {
    if (!ROLE_PERMISSIONS[role]) {
        return false;
    }
    const englishStatus = STATUS_MAPPING[variantStatus] || variantStatus;
    const allowedStatuses = ROLE_PERMISSIONS[role].variantAccessStates;
    return allowedStatuses.includes(englishStatus);
};

// Può modificare colona 'ACTIONS' tag e badge
export const canModifyTagsBadges = (role) => {
    return hasPermission(role, 'canModifyTagsBadges');
};

export const canViewNotes = (role, variantStatus) => {
    if (!ROLE_PERMISSIONS[role]) {
        return false;
    }
    const englishStatus = STATUS_MAPPING[variantStatus] || variantStatus;
    return ROLE_PERMISSIONS[role].canViewNotes.includes(englishStatus);
};

export const canAssignTo = (role) => {
    return hasPermission(role, 'canAssignTo');
};

// Funzione per determinare se il bottone Validate è disabilitato
export const isValidateDisabled = (status) => {
    return status === 'Incompleto'; // Disabilita se lo stato è 'Incompleto'
};

// Funzione per determinare se il bottone Decline è disabilitato
export const isDeclineDisabled = (status) => {
    return status === 'Incompleto'; // Disabilita se lo stato è 'Incompleto'
};